import React from 'react'

const Cookie = () => {
  return (
    <div>Cookie</div>
  )
}

export { Cookie }
